import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Post from '../entities/post'
import Category from '../entities/category'
import Author from '../entities/author'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface PostState extends ListState<Post> {
    post: Post,
    authors: Array<Author>,
    categories: Array<Category>,
    categ: any,
    postCategories: Array<Category>,
}
class PostMutations extends ListMutations<Post>{

}
class PostModule extends ListModule<PostState, any, Post>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Post>(),
        categories: new Array<Category>(),
        categ: new Array<number>(),
        postCategories: new Array<Category>(),
        authors: new Array<Author>(),
        postAuthors: new Array<Author>(),
        loading: false,
        post: new Post(),
    }
    actions = {
        async getAll(context: ActionContext<PostState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Post/GetAll', {
                params: payload.data, paramsSerializer: (params) => {
                    const keys = Object.keys(params);
                    let options = '';

                    keys.forEach((key) => {
                        const isParamTypeObject = typeof params[key] === 'object';
                        const isParamTypeArray = isParamTypeObject && (params[key].length >= 0);

                        if (!isParamTypeObject) {
                            options += `${key}=${params[key]}&`;
                        }

                        if (isParamTypeObject && isParamTypeArray) {
                            params[key].forEach((element) => {
                                options += `${key}=${element}&`;
                            });
                        }
                    });

                    return options ? options.slice(0, -1) : options;
                }
            });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Post>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getAllByCategory(context: ActionContext<PostState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Post/GetAllByCategory', {
                params: payload.data, paramsSerializer: (params) => {
                    const keys = Object.keys(params);
                    let options = '';

                    keys.forEach((key) => {
                        const isParamTypeObject = typeof params[key] === 'object';
                        const isParamTypeArray = isParamTypeObject && (params[key].length >= 0);

                        if (!isParamTypeObject) {
                            options += `${key}=${params[key]}&`;
                        }

                        if (isParamTypeObject && isParamTypeArray) {
                            params[key].forEach((element) => {
                                options += `${key}=${element}&`;
                            });
                        }
                    });

                    return options ? options.slice(0, -1) : options;
                }
            });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<Post>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<PostState, any>, payload: any) {
            await Ajax.post('/api/services/app/Post/Create', payload.data);
        },
        async update(context: ActionContext<PostState, any>, payload: any) {
            await Ajax.put('/api/services/app/Post/Update', payload.data);
        },
        async delete(context: ActionContext<PostState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Post/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<PostState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Post/Get?Id=' + payload.id);
            return reponse.data.result as Post;
        },
        async getPost(context: ActionContext<PostState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Post/Get?Id=' + payload.data.Id);
            return reponse.data.result as Post;
        },
        async getAllAuthors(context: ActionContext<PostState, any>) {
            let reponse = await Ajax.get('/api/services/app/Author/GetAll');
            context.state.authors = reponse.data.result.items;
        },
        async getPostAuthors(context: ActionContext<PostState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Post/GetPostAuthors?Id=' + payload.data.id);
            let array = []
            reponse.data.result.forEach(element => {
                array.push(element.name + element.surname);
            })
            context.state.post.authors = array;
            //context.state.postCategories=reponse.data.result.items;
        },
        async getAllCategories(context: ActionContext<PostState, any>) {
            let reponse = await Ajax.get('/api/services/app/Category/GetAll');
            context.state.categories = reponse.data.result.items;
        },
        async getPostCategories(context: ActionContext<PostState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Post/GetPostCategories?Id=' + payload.data.id);
            let array = []
            reponse.data.result.forEach(element => {
                array.push(element.simpleCategoryName);
            })
            context.state.post.categories = array;
            //context.state.postCategories=reponse.data.result.items;
        },
        async up(context: ActionContext<PostState, any>, payload: any) {
            await Ajax.post('/api/services/app/Post/Up?PostId=' + payload.data.id + '&CategoryId=' + payload.data.categoryId);
        },
        async down(context: ActionContext<PostState, any>, payload: any) {
            await Ajax.post('/api/services/app/Post/Down?PostId=' + payload.data.id + '&CategoryId=' + payload.data.categoryId);
        },
    };
    mutations = {
        setCurrentPage(state: PostState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PostState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: PostState, post: Post) {
            state.post = post;
        },
        setId(state: PostState, id: number) {
            state.post.id = id;
        },
        updateContent(state: PostState, content: string) {
            state.post.content = content;
        },
        setPost(state: PostState, post: Post) {
            state.post = post;
        },
        setCategories(state: PostState, category: number[]) {
            state.categ = category
        }
    }
}
const postModule = new PostModule();
export default postModule;